import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { VTextField } from 'vuetify/lib'
import i18n from './i18n'
import axios from 'axios'
import { VueMaskDirective } from 'v-mask'
import VeeValidate from 'vee-validate'
import VCurrencyField from 'v-currency-field'
import IdleVue from 'idle-vue'

const isSavitarna = window.location.host === process.env.VUE_APP_SAVITARNA_HOST
const isNtrPaslaugos = window.location.pathname.includes('ntr-paslaugos')

import('./assets/scss/theme.sass')
import('./assets/scss/global.scss')
import('./assets/neigalieji.js')

// if (isSavitarna && isNtrPaslaugos) {
//   // import('./assets/scss/globalNtrPaslaugos.scss')
//   // import('./assets/scss/elementsColorNtr.scss')
// } else {
//   import('./assets/scss/global.scss')
//   // import('./assets/scss/elementsColor.scss')
// }

if (isSavitarna) {
  const savitarnaStyle = process.env.VUE_APP_SAVITARNA_STYLE ?? 'savitarna.css'
  import('./assets/scss/' + savitarnaStyle)

  if (isNtrPaslaugos) {
    import('./assets/scss/savitarnaNtrPaslaugos.scss')
  } else {
    import('./assets/scss/savitarnaTurtas.css')
  }
}

document.fonts.ready.then(function() {
  window.dispatchEvent(new Event('resize'))
})

const ComponentContext = require.context(
  './components/elements',
  true,
  /\.vue$/i,
  'lazy'
)

ComponentContext.keys().forEach(componentFilePath => {
  const componentName = componentFilePath
    .split('/')
    .pop()
    .split('.')[0]
  Vue.component(componentName, () => ComponentContext(componentFilePath))
})

axios.defaults.baseURL = store.getters.appBaseApi
axios.interceptors.request.use(config => {
  config.timeout = 5400000 //300000
  config.headers['Access-Control-Allow-Origin'] =
    process.env.VUE_APP_ALLOWED_ORIGINS
  config.headers['Content-Type'] = 'application/json'
  config.headers['Authorization'] = 'Bearer ' + store.getters.getAccessToken
  return config
})
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status == 401) {
      window._VMA.$emit('AUTH_FAILED')
      return
    }
    return Promise.reject(error)
  }
)
Vue.prototype.$axios = axios

Vue.directive('mask', VueMaskDirective)

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField)

// const idleEventsHub = new Vue()
const idleOptions = {
  // eventEmitter: idleEventsHub,
  store,
  idleTime: store.getters.getExpiresIn,
  startAtIdle: false,
  keepTracking: true,
}
Vue.use(IdleVue, idleOptions)

Vue.config.productionTip = false

const veeConfig = {
  events: 'blur',
  inject: false,
}
Vue.use(VeeValidate, veeConfig)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
